function initCustomLanding() {

  const template = document.getElementById('marquee-set');
  const container = document.getElementById('marquee-content');

  // Prevent duplicate rendering in editor
  if (container) {
    container.innerHTML = '';
  }

  if (template && container) {
    for (let i = 0; i < 4; i++) {
      const clone = template.content.cloneNode(true);
      container.appendChild(clone);
    }
  }

  // Kaaram Classics: Mobile Fade-In/Fade-Out & Desktop Smooth Slide
  const nextBtn = document.querySelector('.carousel-next-btn');
  const prevBtn = document.querySelector('.carousel-prev-btn');
  const classicsGrid = document.querySelector('.classics-grid');
  const classicsWrapper = document.querySelector('.classics-grid-wrapper') || document.querySelector('.classics-container');

  if (classicsGrid) {
    let isSliding = false;
    let autoScrollInterval = null;

    const slideNext = (fast = false) => {
      if (isSliding || !classicsGrid.children.length) return;
      isSliding = true;

      const isMobile = window.innerWidth < 1024;

      if (isMobile) {
        // Mobile: Smooth Cross Fade
        const currentCard = classicsGrid.children[0];
        const fadeOutTime = fast ? 150 : 200;
        const fadeInTime = fast ? 180 : 240;

        currentCard.style.transition = `opacity ${fadeOutTime}ms ease`;
        currentCard.style.opacity = '0';

        setTimeout(() => {
          classicsGrid.appendChild(currentCard);
          const newCurrentCard = classicsGrid.children[0];
          newCurrentCard.style.transition = 'none';
          newCurrentCard.style.opacity = '0';
          void newCurrentCard.offsetHeight; // Force DOM reflow

          newCurrentCard.style.transition = `opacity ${fadeInTime}ms ease`;
          newCurrentCard.style.opacity = '1';
          currentCard.style.opacity = '1'; // restore original

          setTimeout(() => {
            isSliding = false;
          }, fadeInTime);
        }, fadeOutTime);
      } else {
        // Desktop: Fast Linear Slide
        const firstCard = classicsGrid.children[0];
        const gap = parseInt(window.getComputedStyle(classicsGrid).gap) || 0;
        const slideWidth = firstCard.offsetWidth + gap;
        const duration = fast ? 180 : 240;

        classicsGrid.style.transition = `transform ${duration}ms cubic-bezier(0.2, 0.8, 0.2, 1)`;
        classicsGrid.style.transform = `translateX(-${slideWidth}px)`;

        setTimeout(() => {
          classicsGrid.style.transition = 'none';
          classicsGrid.appendChild(firstCard);
          classicsGrid.style.transform = 'translateX(0)';
          isSliding = false;
        }, duration);
      }
    };

    const slidePrev = (fast = false) => {
      if (isSliding || !classicsGrid.children.length) return;
      isSliding = true;

      const isMobile = window.innerWidth < 1024;

      if (isMobile) {
        // Mobile: Smooth Cross Fade Prev
        const currentCard = classicsGrid.children[0];
        const lastCard = classicsGrid.children[classicsGrid.children.length - 1];
        const fadeOutTime = fast ? 150 : 200;
        const fadeInTime = fast ? 180 : 240;

        currentCard.style.transition = `opacity ${fadeOutTime}ms ease`;
        currentCard.style.opacity = '0';

        setTimeout(() => {
          classicsGrid.insertBefore(lastCard, classicsGrid.firstChild);
          lastCard.style.transition = 'none';
          lastCard.style.opacity = '0';
          void lastCard.offsetHeight; // Force DOM reflow

          lastCard.style.transition = `opacity ${fadeInTime}ms ease`;
          lastCard.style.opacity = '1';
          currentCard.style.opacity = '1'; // restore

          setTimeout(() => {
            isSliding = false;
          }, fadeInTime);
        }, fadeOutTime);
      } else {
        // Desktop: Fast Linear Slide Prev
        const lastCard = classicsGrid.children[classicsGrid.children.length - 1];
        const gap = parseInt(window.getComputedStyle(classicsGrid).gap) || 0;
        const slideWidth = lastCard.offsetWidth + gap;
        const duration = fast ? 180 : 240;

        classicsGrid.style.transition = 'none';
        classicsGrid.insertBefore(lastCard, classicsGrid.firstChild);
        classicsGrid.style.transform = `translateX(-${slideWidth}px)`;
        void classicsGrid.offsetHeight; // Force DOM reflow

        classicsGrid.style.transition = `transform ${duration}ms cubic-bezier(0.2, 0.8, 0.2, 1)`;
        classicsGrid.style.transform = 'translateX(0)';

        setTimeout(() => {
          classicsGrid.style.transition = 'none';
          isSliding = false;
        }, duration);
      }
    };

    // Auto-scroll handler (smooth slightly faster auto-scroll, especially on mobile)
    const startAutoScroll = () => {
      stopAutoScroll();
      autoScrollInterval = setInterval(() => {
        if (!isSliding && window.innerWidth < 1024) {
          slideNext(false);
        }
      }, 2600);
    };

    const stopAutoScroll = () => {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
      }
    };

    startAutoScroll();

    // Pause auto-scroll on touch/hover, resume on release
    if (classicsWrapper) {
      classicsWrapper.addEventListener('touchstart', stopAutoScroll, { passive: true });
      classicsWrapper.addEventListener('touchend', () => {
        setTimeout(startAutoScroll, 3000);
      }, { passive: true });
      classicsWrapper.addEventListener('mouseenter', stopAutoScroll);
      classicsWrapper.addEventListener('mouseleave', startAutoScroll);
    }

    // Fast Arrow Navigation
    if (nextBtn) {
      const newNext = nextBtn.cloneNode(true);
      nextBtn.parentNode.replaceChild(newNext, nextBtn);
      newNext.addEventListener('click', (e) => {
        e.preventDefault();
        stopAutoScroll();
        slideNext(true);
        setTimeout(startAutoScroll, 4000);
      });
    }

    if (prevBtn) {
      const newPrev = prevBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(newPrev, prevBtn);
      newPrev.addEventListener('click', (e) => {
        e.preventDefault();
        stopAutoScroll();
        slidePrev(true);
        setTimeout(startAutoScroll, 4000);
      });
    }
  }

  // Mascot Scroll Parallax (Ultra-smooth 60fps with IntersectionObserver and requestAnimationFrame)
  const footerSection = document.querySelector('.footer-section');
  const mascot = document.querySelector('.story-mascot-wrapper');

  if (footerSection && mascot && !window.__kaaramMascotActive) {
    window.__kaaramMascotActive = true;
    let isIntersecting = false;
    let ticking = false;
    let lastTranslateX = -1;

    const updateMascot = () => {
      const rect = footerSection.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const maxMove = Math.max(0, window.innerWidth - mascot.offsetWidth - 5);

      const visibleHeight = windowHeight - rect.top;
      const scrollThreshold = Math.max(150, windowHeight * 0.75);
      const progress = Math.max(0, Math.min(visibleHeight / scrollThreshold, 1));

      const translateX = Math.round(progress * maxMove * 10) / 10;
      if (translateX !== lastTranslateX) {
        mascot.style.transform = `translate3d(${translateX}px, 0, 0)`;
        lastTranslateX = translateX;
      }
      ticking = false;
    };

    const handleMascotScroll = () => {
      if (!isIntersecting) return;
      if (!ticking) {
        window.requestAnimationFrame(updateMascot);
        ticking = true;
      }
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          isIntersecting = entry.isIntersecting;
          if (isIntersecting) {
            updateMascot();
          }
        });
      }, { rootMargin: '300px 0px' });
      observer.observe(footerSection);
    } else {
      isIntersecting = true;
    }

    window.addEventListener('scroll', handleMascotScroll, { passive: true });
    window.addEventListener('resize', () => {
      updateMascot();
    }, { passive: true });
    
    updateMascot();
    setTimeout(updateMascot, 200);
  }

  // Testimonial Carousel - simple in-place fade out / fade in
  const tNextBtn = document.querySelector('.testimonial-next-btn');
  const tPrevBtn = document.querySelector('.testimonial-prev-btn');
  const tGrid = document.querySelector('.testimonial-grid');

  if (tGrid && (tNextBtn || tPrevBtn)) {
    const tCards = Array.from(tGrid.querySelectorAll('.testimonial-card'));
    let activeIndex = tCards.findIndex(card => card.classList.contains('active'));
    if (activeIndex === -1) {
      activeIndex = 0;
      if (tCards[0]) tCards[0].classList.add('active');
    }

    if (tNextBtn) {
      const newTNextBtn = tNextBtn.cloneNode(true);
      tNextBtn.parentNode.replaceChild(newTNextBtn, tNextBtn);
      newTNextBtn.addEventListener('click', () => {
        tCards[activeIndex].classList.remove('active');
        activeIndex = (activeIndex + 1) % tCards.length;
        tCards[activeIndex].classList.add('active');
      });
    }

    if (tPrevBtn) {
      const newTPrevBtn = tPrevBtn.cloneNode(true);
      tPrevBtn.parentNode.replaceChild(newTPrevBtn, tPrevBtn);
      newTPrevBtn.addEventListener('click', () => {
        tCards[activeIndex].classList.remove('active');
        activeIndex = (activeIndex - 1 + tCards.length) % tCards.length;
        tCards[activeIndex].classList.add('active');
      });
    }
  }

  // WhatsApp Widget Toggle & Close Handler
  const whatsappToggleBtn = document.getElementById('whatsappToggleBtn');
  const whatsappChatBox = document.getElementById('whatsappChatBox');
  const whatsappCloseBtn = document.getElementById('whatsappCloseBtn');

  if (whatsappToggleBtn && whatsappChatBox) {
    // Clone and replace to clear duplicate events in editor preview
    const newToggleBtn = whatsappToggleBtn.cloneNode(true);
    whatsappToggleBtn.parentNode.replaceChild(newToggleBtn, whatsappToggleBtn);

    newToggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      whatsappChatBox.classList.toggle('active');
    });

    if (whatsappCloseBtn) {
      whatsappCloseBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        whatsappChatBox.classList.remove('active');
      });
    }

    // Close chatbox when clicking outside the widget
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.whatsapp-widget')) {
        whatsappChatBox.classList.remove('active');
      }
    });
  }

  // Newsletter Signup Popup after 3 seconds of landing
  const newsletterPopup = document.getElementById('newsletterPopup');
  const newsletterCloseBtn = document.getElementById('newsletterCloseBtn');
  const newsletterForm = document.getElementById('newsletterForm');

  if (newsletterPopup) {
    setTimeout(() => {
      // Show the popup
      newsletterPopup.classList.add('active');
    }, 3000);

    const closePopup = () => {
      newsletterPopup.classList.remove('active');
    };

    if (newsletterCloseBtn) {
      newsletterCloseBtn.addEventListener('click', closePopup);
    }

    if (newsletterForm) {
      newsletterForm.addEventListener('submit', (e) => {
        e.preventDefault();
        closePopup();
        // Visual confirmation feedback
        const emailInput = newsletterForm.querySelector('.popup-input');
        if (emailInput) {
          alert(`Welcome to the Kaaram club! 🌶️\nSubscribed: ${emailInput.value}`);
          emailInput.value = '';
        }
      });
    }

    // Close when clicking on the dark overlay background
    newsletterPopup.addEventListener('click', (e) => {
      if (e.target === newsletterPopup) {
        closePopup();
      }
    });
  }

  // Mobile Menu Drawer Handler
  const mobileMenuToggle = document.getElementById('mobileMenuToggle');
  const mobileMenuDrawer = document.getElementById('mobileMenuDrawer');
  const mobileMenuClose = document.getElementById('mobileMenuClose');

  if (mobileMenuDrawer && mobileMenuDrawer.parentElement !== document.body) {
    document.body.appendChild(mobileMenuDrawer);
  }

  if (mobileMenuToggle && mobileMenuDrawer) {
    mobileMenuToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      mobileMenuDrawer.classList.add('active');
    });

    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', (e) => {
        e.stopPropagation();
        mobileMenuDrawer.classList.remove('active');
      });
    }

    // Close drawer when any link inside it is clicked
    const drawerLinks = mobileMenuDrawer.querySelectorAll('.mobile-drawer-nav a');
    drawerLinks.forEach(link => {
      link.addEventListener('click', () => {
        mobileMenuDrawer.classList.remove('active');
      });
    });

    // Close drawer when clicking outside
    document.addEventListener('click', (e) => {
      if (mobileMenuDrawer.classList.contains('active') && !mobileMenuDrawer.contains(e.target) && !mobileMenuToggle.contains(e.target)) {
        mobileMenuDrawer.classList.remove('active');
      }
    });
  }

  // Auto slide hero section image loop (always right to left, infinite seamless)
  const heroSliderTrack = document.getElementById('heroSliderTrack');
  const heroPrevBtn = document.getElementById('heroPrevBtn');
  const heroNextBtn = document.getElementById('heroNextBtn');
  const heroDotsContainer = document.getElementById('heroDotsContainer');

  if (heroSliderTrack) {
    const slides = Array.from(heroSliderTrack.children);
    if (slides.length > 1) {
      // Clone the first slide and append it to the end
      const firstClone = slides[0].cloneNode(true);
      heroSliderTrack.appendChild(firstClone);

      let currentIndex = 0;
      let isHeroSliding = false;

      // Function to update active dots
      const updateHeroDots = (index) => {
        if (!heroDotsContainer) return;
        const dots = heroDotsContainer.querySelectorAll('.hero-dot');
        dots.forEach((dot, idx) => {
          if (idx === (index % 2)) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      };

      // Function to transition to slide index
      const goToHeroSlide = (index, transition = true) => {
        if (transition) {
          heroSliderTrack.style.transition = 'transform 1.8s cubic-bezier(0.77, 0, 0.175, 1) !important';
          heroSliderTrack.style.setProperty('transition', 'transform 1.8s cubic-bezier(0.77, 0, 0.175, 1)', 'important');
        } else {
          heroSliderTrack.style.transition = 'none';
          heroSliderTrack.style.setProperty('transition', 'none', 'important');
        }
        
        heroSliderTrack.style.transform = `translateX(-${index * 100}vw)`;
        currentIndex = index;
        updateHeroDots(currentIndex);

        // Seamless snap back from clone (index 2) to original (index 0)
        if (currentIndex === 2) {
          setTimeout(() => {
            goToHeroSlide(0, false);
          }, 1800); // matches the 1.8s transition
        }
      };

      // Loop timer handler
      const startHeroInterval = () => {
        if (window.heroSliderInterval) {
          clearInterval(window.heroSliderInterval);
        }
        window.heroSliderInterval = setInterval(() => {
          if (!isHeroSliding) {
            goToHeroSlide(currentIndex + 1);
          }
        }, 7000); // Slide changes every 7 seconds
      };

      // Start loop
      startHeroInterval();

      // Controls: Next Button Click
      if (heroNextBtn) {
        const newNext = heroNextBtn.cloneNode(true);
        heroNextBtn.parentNode.replaceChild(newNext, heroNextBtn);
        newNext.addEventListener('click', () => {
          if (isHeroSliding) return;
          isHeroSliding = true;
          const nextIndex = (currentIndex === 2) ? 1 : currentIndex + 1;
          goToHeroSlide(nextIndex);
          startHeroInterval();
          setTimeout(() => { isHeroSliding = false; }, 1800);
        });
      }

      // Controls: Prev Button Click
      if (heroPrevBtn) {
        const newPrev = heroPrevBtn.cloneNode(true);
        heroPrevBtn.parentNode.replaceChild(newPrev, heroPrevBtn);
        newPrev.addEventListener('click', () => {
          if (isHeroSliding) return;
          isHeroSliding = true;
          let prevIndex = currentIndex - 1;
          if (prevIndex < 0) {
            // Snap to clone (index 2) instantly, then slide left to index 1
            goToHeroSlide(2, false);
            setTimeout(() => {
              goToHeroSlide(1);
            }, 50);
          } else {
            goToHeroSlide(prevIndex);
          }
          startHeroInterval();
          setTimeout(() => { isHeroSliding = false; }, 1800);
        });
      }

      // Controls: Dot Indicator Clicks
      if (heroDotsContainer) {
        const dots = heroDotsContainer.querySelectorAll('.hero-dot');
        dots.forEach((dot, idx) => {
          dot.addEventListener('click', () => {
            if (isHeroSliding || currentIndex === idx) return;
            isHeroSliding = true;
            goToHeroSlide(idx);
            startHeroInterval();
            setTimeout(() => { isHeroSliding = false; }, 1800);
          });
        });
      }
    }
  }
}

// Initialize on DOM ready or immediately if already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomLanding);
} else {
  initCustomLanding();
}

// Re-initialize code when section loads/refreshes in Shopify Theme Editor
document.addEventListener('shopify:section:load', (e) => {
  initCustomLanding();
});

// Expandable Search Bar Widget Interaction
document.addEventListener('DOMContentLoaded', () => {
  const searchTriggerBtn = document.getElementById('searchTriggerBtn');
  const searchCloseBtn = document.getElementById('searchCloseBtn');
  const headerSearchWrapper = document.getElementById('headerSearchWrapper');
  const headerNavRight = document.getElementById('headerNavRight');
  const headerSearchInput = document.getElementById('headerSearchInput');

  if (searchTriggerBtn && searchCloseBtn && headerSearchWrapper && headerNavRight) {
    searchTriggerBtn.addEventListener('click', (e) => {
      e.preventDefault();
      headerSearchWrapper.classList.add('search-active');
      headerNavRight.classList.add('search-active');
      if (headerSearchInput) {
        setTimeout(() => {
          headerSearchInput.focus();
        }, 150);
      }
    });

    searchCloseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      headerSearchWrapper.classList.remove('search-active');
      headerNavRight.classList.remove('search-active');
      if (headerSearchInput) {
        headerSearchInput.value = '';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && headerSearchWrapper.classList.contains('search-active')) {
        headerSearchWrapper.classList.remove('search-active');
        headerNavRight.classList.remove('search-active');
        if (headerSearchInput) {
          headerSearchInput.value = '';
        }
      }
    });
  }
});

// Global Add to Cart AJAX Handler for all .add-cart-btn-svg buttons
if (!window.__kaaramCartAddBound) {
  window.__kaaramCartAddBound = true;
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.add-cart-btn-svg');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    // Prevent duplicate clicks / in-flight requests
    if (btn.disabled || btn.getAttribute('data-submitting') === 'true') {
      return;
    }
    btn.setAttribute('data-submitting', 'true');
    btn.disabled = true;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn('No data-variant-id attribute found on button');
      btn.removeAttribute('data-submitting');
      btn.disabled = false;
      return;
    }

    // Visual feedback: click animation
    btn.style.transform = 'scale(0.95)';
    setTimeout(() => { btn.style.transform = ''; }, 150);

    const cartDrawer = document.querySelector('cart-drawer');
    const sectionsToFetch = cartDrawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', sectionsToFetch);
    formData.append('sections_url', window.location.pathname);

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      btn.removeAttribute('data-submitting');
      btn.disabled = false;

      if (data.status || data.errors) {
        console.error('Cart add error:', data.description || data.errors);
        window.location.href = '/cart';
        return;
      }

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        fetch(rootUrl + 'cart.js')
          .then(r => r.json())
          .then(cart => {
            const countBubbles = document.querySelectorAll('.cart-count-bubble span');
            countBubbles.forEach(el => { el.textContent = cart.item_count; });

            if (cartDrawer) {
              cartDrawer.classList.add('active');
            } else {
              window.location.href = '/cart';
            }
          });
      }
    })
    .catch(err => {
      btn.removeAttribute('data-submitting');
      btn.disabled = false;
      console.error('AJAX add to cart failed:', err);
      window.location.href = '/cart';
    });
  });
}


// Real-time Cart Count Hydration & Sync
function syncHeaderCartCount() {
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  fetch(rootUrl + 'cart.js')
    .then(r => r.json())
    .then(cart => {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && !bubble.querySelector('.cart-text-label')) {
        bubble.innerHTML = '<span class="cart-text-label">CART</span><span class="header-cart-count' + (cart.item_count === 0 ? ' hidden' : '') + '" id="headerCartCount" data-cart-count>' + cart.item_count + '</span><span class="visually-hidden" style="display:none!important;">Cart</span>';
      }
      const countEls = document.querySelectorAll('.header-cart-count, .cart-count-bubble span');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) {
          el.classList.remove('hidden');
          el.style.display = 'inline-flex';
        } else {
          el.classList.add('hidden');
          el.style.display = 'none';
        }
      });
    })
    .catch(() => {});
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncHeaderCartCount);
} else {
  syncHeaderCartCount();
}
window.addEventListener('pageshow', syncHeaderCartCount);
